import {Component, inject, PLATFORM_ID} from '@angular/core';
import {NgIcon, provideIcons} from '@ng-icons/core';
import {matChecklistOutline, matHandshakeOutline, matHomeRepairServiceOutline} from '@ng-icons/material-icons/outline';
import {tablerAdjustmentsHeart, tablerChartArrows, tablerExchange} from '@ng-icons/tabler-icons';
import {NgxNumberTickerComponent} from '@omnedia/ngx-number-ticker';
import {Button} from 'primeng/button';
import {AuctionsSolutions} from '../../../shared/model/auctions-solutions.model';
import {isPlatformBrowser} from '@angular/common';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../../shared/enum/gtm-cookie-consent.enum';
import {Theme} from '../../../shared/enum/theme.enum';
import {PixelEventName} from '../../../shared/analytics/meta/types/pixel.types';
import {GoogleAnalyticsService} from '../../../shared/analytics/google/google-analytics.service';
import {PixelService} from '../../../shared/analytics/meta/pixel.service';

@Component({
  selector: 'app-auctions-solutions',
  imports: [
    NgxNumberTickerComponent,
    NgIcon,
    Button
  ],
  templateUrl: './auctions-solutions.component.html',
  styleUrl: './auctions-solutions.component.scss',
  providers: [provideIcons({
      matHandshakeOutline,
      tablerChartArrows,
      matHomeRepairServiceOutline,
      tablerAdjustmentsHeart,
      tablerExchange,
      matChecklistOutline
    }
  )]
})
export class AuctionsSolutionsComponent {
  protected solutionsData: AuctionsSolutions[] = [];
  private readonly platformId = inject(PLATFORM_ID);
  protected readonly isBrowser = isPlatformBrowser(this.platformId)

  constructor(
    private readonly analyticsService: GoogleAnalyticsService,
    private readonly pixelService: PixelService
  ) {
    this.solutionsData = [
      {
        title: "Dostępność",
        content: "Auta dostępne od ręki lub z krótkim terminem dostawy"
      },
      {
        title: "Koszty po kontrolą",
        content: "Stała, przewidywalna rata miesięczna. Łatwe planowanie budżetu firmowego"
      },
      {
        title: "Ciągłość eksploatacyjna",
        content: "Kompleksowa obsługa w jednej racie (serwis, opony, ubezpieczenie, assistance)"
      },
      {
        title: "Finansowanie na miarę",
        content: "Elastyczne warianty finansowania - dla JDG i MŚP"
      },
      {
        title: "Elastyczna wymiana",
        content: "Możliwość wymiany auta w trakcie umowy. Zawsze aktualna flota dostosowana do rozwoju firmy"
      },
      {
        title: "Transparentny proces",
        content: "Prosty proces online - szybka decyzja leasingowa"
      }
    ];
  }

  protected onCtaClick(): void {
    this.analyticsService.trackEvent({
      event: AnalyticsEventName.RequestCtaClick,
      eventCategory: AnalyticsEventCategory.CTA,
      eventPayload: Theme.AUCTIONS
    });

    this.pixelService.trackEvent(
      PixelEventName.RequestCta, {
        page: Theme.AUCTIONS
      });
  }
}

